export default __webpack_public_path__ + "static/media/Snd_TryS.e71ef381.mp3";